import { isComponentTemplate, type ComponentTemplate } from '@game-platform/theme-constructor';
import { useMe } from '../../auth/MeContext';

export type TemplateName = ComponentTemplate;

/**
 * The template players get when a launch names none (`default_template`).
 * The template pages land on it and mark it in their selector, so an operator
 * tunes what their players actually see unless they pick another on purpose.
 */
export function useDefaultTemplate(): TemplateName {
  const { me } = useMe();
  const name = me?.operator.default_template;
  return isComponentTemplate(name) ? name : 'classic';
}
